import { Prospect } from "rivals/shared/interfaces/Prospect";

export const RIVALS_RATING_DIGITS = 2;

export function inchesToFeet(inches: number | null): string {
  const inchesPerFoot = 12;
  return inches
    ? `${Math.floor(inches / inchesPerFoot)}'${Math.floor(
        inches % inchesPerFoot
      )}"`
    : "";
}

export interface RankInfo {
  rank: number | null;
  rankChange: number;
  rankType: string;
  rankUrl: string | null;
}

export function getRankArgs(prospect: Prospect, embed = false): RankInfo[] {
  const nationalRankLabel = "natl";
  const stateRankLabel = "st";
  const positionRankLabel = "pos";

  const {
    nationalRank,
    nationalRankChange,
    nationalRankUrl,
    stateRank,
    stateRankChange,
    stateRankUrl,
    positionRank,
    positionRankChange,
    positionRankUrl
  } = prospect;

  return [
    {
      rank: nationalRank,
      rankChange: nationalRankChange,
      rankType: nationalRankLabel,
      rankUrl: embed ? null : nationalRankUrl
    },
    {
      rank: stateRank,
      rankChange: stateRankChange,
      rankType: stateRankLabel,
      rankUrl: embed ? null : stateRankUrl
    },
    {
      rank: positionRank,
      rankChange: positionRankChange,
      rankType: positionRankLabel,
      rankUrl: embed ? null : positionRankUrl
    }
  ] as RankInfo[];
}
